<template>
    <div class="nps-label-container" :style="{'--nps-button-color': $store.getters.getNpsButtonColor}">
        <label
                :for="question.uid"
                v-bind:class="{ nps_checked: model.selected}"
                v-bind:id="'nps_' + index"
                v-on:click="setRadio(model.uid)"
                v-for="(model, index) in question.answers" v-bind:key="model.uid"
                class="checkbox-questions-label nps-label" style="margin-top:10px;"
        >
            {{ model.title }}

            <input style="display:none;" type="radio"
                   :name="question.uid"
                   :value="model.uid"
                   v-bind:checked="model.selected">
        </label>
        <transition name="fade">
            <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
        </transition>
        <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
    </div>
</template>

<script>
    import Vue from 'vue';
    import Comment from './Comment';

    export default {
        name: 'nps',
        props: ['question'],
        data() {
            return {
                answerSelected: false,
                showComment: false,
                commentPlaceholder: false,
                commentName: false
            }
        },
        methods: {
            setRadio: function (uid) {
                this.showComment = false;
                this.commentPlaceholder = false;
                this.commentName = false;

                this.$emit("inputClick", uid);
                this.$emit("checkDependency", uid);

                this.question.answers.forEach((item, index) => {
                    if (item.uid === uid) {
                        item.selected = true;
                        if (item.is_allow_comment) {
                            this.showComment = true;
                            this.commentPlaceholder = item.comment_placeholder;
                            this.commentName = 'comment_' + this.question.uid;
                        }
                        Vue.set(this.question.answers, index, item);
                    } else {
                        item.selected = false;
                        Vue.set(this.question.answers, index, item);
                    }
                });
            }
        },
        components: {
            Comment
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .10s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>
